import React from 'react';
import { Label } from "../commons/translations/Label";
import { useAuthContext } from "../launcher/auth/LauncherAuthContext";
import { useLoginButton } from "../launcher/auth/login-button/useLoginButton";
import { LoginButton } from "../launcher/auth/login-button/component";
import { LoadingOverlay } from "../launcher/common/loading/component";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";

export interface ReservationCtaSectionProps {
    canAcceptReservations: boolean;
    hasUserAlreadyReserved?: boolean;
    alreadyReservedContent?: React.ReactNode;
    isHostOrGm?: boolean;
    hostOrGmContent?: React.ReactNode;
    children: React.ReactNode;
}

export const ReservationCtaSection: React.FC<ReservationCtaSectionProps> = ({
    canAcceptReservations,
    hasUserAlreadyReserved = false,
    alreadyReservedContent,
    isHostOrGm = false,
    hostOrGmContent,
    children
}) => {
    const { isUserLoggedIn, isUserVerified } = useAuthContext();
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
    const { working, setWorking, login, captureUser } = useLoginButton(() => navigate(currentPath), currentPath);

    return (
        <div id="reservation-call-to-action-section">
            <LoadingOverlay working={working} />
            {isHostOrGm && (
                hostOrGmContent || (
                    <div>
                        <Label strong trl={'reservation.cta.hostOrGm'} />
                    </div>
                )
            )}
            {!isHostOrGm && hasUserAlreadyReserved && (
                alreadyReservedContent || (
                    <div>
                        <Label strong trl={'reservation.card.already.reserved'} />
                    </div>
                )
            )}
            {!isHostOrGm && !hasUserAlreadyReserved && !canAcceptReservations && (
                <div>
                    <Label strong trl={'reservation.card.seats.full'} />
                </div>
            )}
            {!isHostOrGm && !hasUserAlreadyReserved && canAcceptReservations && !isUserLoggedIn() && (
                <div>
                    <Label strong trl={'reservation.card.not.logged.in'} />
                    <div style={{ marginTop: '8px' }}>
                        <LoginButton setWorking={setWorking} login={login} captureUser={captureUser} />
                    </div>
                </div>
            )}
            {!isHostOrGm && !hasUserAlreadyReserved && canAcceptReservations && isUserLoggedIn() && !isUserVerified() && (
                <div>
                    <Label strong trl={'reservation.card.not.verified'} />
                </div>
            )}
            {!isHostOrGm && !hasUserAlreadyReserved && canAcceptReservations && isUserLoggedIn() && isUserVerified() && (
                children
            )}
        </div>
    );
};
